module.exports = __webpack_public_path__ + "img/catalog (3).b83de8c4.jpg";